import { render, staticRenderFns } from "./Recebiveis.vue?vue&type=template&id=7f10a700"
import script from "./Recebiveis.vue?vue&type=script&lang=js"
export * from "./Recebiveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports